module.exports = "<canvas></canvas>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/crewpdfviewersinglepage.html
// module id = 1241
// module chunks = 1